import DeudaShow from './DeudaShow'
export {DeudaShow}
export default DeudaShow
